import React, { useEffect, useState } from "react";
import { ScMarkupBar } from "./styled";
import { Icon } from "../Icon/Icon";
import { useRecoilState, useRecoilValue } from "recoil";
import { ChevronLeft, ChevronRight, Info } from "react-feather";
import {
  controlState,
  markupStepsState,
  stepState,
  zoomState,
} from "../markupAtoms";
import ModalInfo from "./ModalInfo";

interface MarkupControlProps {
  prevImage: () => void;
  nextImage: () => void;
}

export const MarkupControl: React.FC<MarkupControlProps> = ({
  prevImage,
  nextImage,
}) => {
  const [control, setControl] = useRecoilState(controlState);
  const [zoom, setZoom] = useRecoilState(zoomState);
  const [showInfo, setShowInfo] = useState(false);

  useEffect(() => {
    const zoomHandler = (e: any) => {
      if (e.ctrlKey) {
        e.preventDefault();
        setZoom((zoom) => (e.wheelDelta > 0 ? zoom + 10 : zoom - 10));
      } else {
        e.preventDefault();
        setZoom((zoom) => (e.wheelDelta > 0 ? zoom + 20 : zoom - 20));
      }
    };

    document.body.addEventListener("mousewheel", zoomHandler, {
      passive: false,
    });

    return () => {
      document.body.removeEventListener("mousewheel", zoomHandler);
    };
  }, []);

  return (
    <ScMarkupBar>
      <div className="markup-control-container">
        <div className="tab-left">
          <button
            className={["icon", control === "select" ? "active" : ""].join(" ")}
            title="Курсор"
            onClick={() => setControl("select")}
          >
            <Icon refIcon={"Cursor"} />
          </button>

          <button
            className={["icon", control === "drag" ? "active" : ""].join(" ")}
            title="Перетащить изображение"
            onClick={() => setControl("drag")}
          >
            <Icon refIcon={control === "drag" ? "PointerDrag" : "Pointer"} />
          </button>
          <button
            className="icon info"
            title="Информация для разметки"
            onClick={() => setShowInfo(true)}
          >
            <Info size={20} />
          </button>
        </div>
        <div className="tab-nav">
          <button
            className="icon info"
            title="Предыдущее изображение"
            onClick={prevImage}
          >
            <ChevronLeft size={20} />
          </button>
          <button
            className="icon info"
            title="Следующее изображение"
            onClick={nextImage}
          >
            <ChevronRight size={20} />
          </button>
        </div>
        <div className="tab-right control-items">
          <button
            className="icon"
            title="Уменьшить на 10% zoom"
            onClick={() => setZoom(zoom - 10)}
          >
            <Icon refIcon={"ZoomOut"} />
          </button>
          <span className="zoom">{zoom}%</span>
          <button
            className="icon"
            title="Увелечить на 10% zoom"
            onClick={() => setZoom(zoom + 10)}
          >
            <Icon refIcon={"ZoomIn"} />
          </button>
          <button
            className="icon"
            title="Вернуть 100% zoom"
            onClick={() => setZoom(100)}
          >
            <Icon refIcon={"Maximize"} />
          </button>
          <Steps />
        </div>
      </div>
      {showInfo && <ModalInfo onClose={() => setShowInfo(false)} />}
    </ScMarkupBar>
  );
};

export const Steps: React.FC = () => {
  const [step, setStep] = useRecoilState(stepState);
  const markupSteps = useRecoilValue(markupStepsState);

  useEffect(() => {
    setStep(markupSteps.length);
  }, [markupSteps]);

  const increment = () => {
    if (step < markupSteps.length + 1) {
      setStep(step + 1);
    }
  };

  const decrement = () => {
    if (step > 0) {
      setStep(step - 1);
    }
  };

  return (
    <div className="steps">
      <button disabled={step < 2} onClick={() => decrement()}>
        <Icon refIcon={"Rotate"} /> <span>Отменить</span>
      </button>
      <button
        disabled={step < 1 || markupSteps.length === step}
        onClick={() => increment()}
      >
        <span>Повторить</span>
        <Icon refIcon={"Rotate"} />
      </button>
    </div>
  );
};
